import React, { useState, useEffect, useCallback } from 'react';
import { fetchNitaSurveyAnalytics } from '../../api/client';
import NitaSurveyAnalytics from '../NitaSurveyAnalytics/NitaSurveyAnalytics';
import NitaSurveyList from '../NitaSurveyList/NitaSurveyList';

export default function NitaSurveyTab() {
  const [analytics, setAnalytics] = useState(null);

  const loadAnalytics = useCallback(async () => {
    try {
      const res = await fetchNitaSurveyAnalytics();
      setAnalytics(res.data);
    } catch (_e) {
      setAnalytics(null);
    }
  }, []);

  useEffect(() => {
    loadAnalytics();
  }, [loadAnalytics]);

  return (
    <div>
      <NitaSurveyAnalytics analytics={analytics} />
      <NitaSurveyList />
    </div>
  );
}
